import { t } from '../i18n';

/**
 * Words for what uses a master data entry (0066): "2 profesionales · 40 turnos",
 * from the counts master_data_usage_detail returns, leaving out what is zero,
 * always in the same order.
 */

const ORDER = [
  'professionals', 'patients', 'treatments', 'sessions',
  'payment_terms', 'cancellation_fees', 'specializations', 'subscription_plans',
];

export const usageLine = (usage) => ORDER
  .filter((kind) => Number(usage?.[kind]) > 0)
  .map((kind) => t(`masterData.usage.${kind}`, { count: Number(usage[kind]) }))
  .join(' · ');
